import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOM_FORMAT } from './schema';

const MUTATION = gql`
  mutation CreateCustomFormat(
    $brandVoiceId: ID!
    $name: String!
    $instructions: String!
    $defaultForGenerationTools: [GenerationToolEnum!]
  ) {
    createCustomFormat(
      brandVoiceId: $brandVoiceId
      name: $name
      instructions: $instructions
      defaultForGenerationTools: $defaultForGenerationTools
    ) {
      ...CustomFormat
    }
  }
  ${FRAGMENT_CUSTOM_FORMAT}
`;

export const createCustomFormat = async ({
  brandVoiceId,
  name,
  instructions,
  defaultForGenerationTools,
}) => {
  const variables = {
    brandVoiceId,
    name,
    instructions,
    defaultForGenerationTools,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(result.data);
};
